import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { parseLensConfigResponse } from 'components/molecules/PricingSimulatorV3/ScenarioLensSection/scenarioLensCatalog.helpers';
import { getLensScenarioConfigQueryKey } from 'components/molecules/PricingSimulatorV3/ScenarioLensSection/scenarioLensConfigCache.helpers';
import type { LensCatalogFetchResult } from 'components/molecules/PricingSimulatorV3/ScenarioLensSection/scenarioLensCatalog.types';
import { ppaUrls } from 'config/urls';

export async function fetchLensScenarioConfig(
    lensId: number,
    scenarioId: number,
): Promise<LensCatalogFetchResult> {
    const response = await axios.get(ppaUrls.getLensScenarioConfigUrl, {
        params: {
            lens_id: lensId,
            scenario_id: scenarioId,
        },
    });

    return {
        lensId,
        catalog: parseLensConfigResponse(response.data),
        raw: response.data,
    };
}

const LENS_SCENARIO_CONFIG_STALE_TIME_MS = 1000 * 60 * 5;

/**
 * Fetches lens config scoped to a scenario — returns only the lens's own
 * attributes (not the full catalog), with scenario-level visibility overlay.
 */
export function useFetchLensScenarioConfig(
    lensId: number | null,
    scenarioId: number | null,
    enabled = true
) {
    return useQuery({
        queryKey: lensId != null && scenarioId != null ? getLensScenarioConfigQueryKey(lensId, scenarioId) : ['ppa-lens-scenario-config', lensId, scenarioId],
        queryFn: () => fetchLensScenarioConfig(lensId as number, scenarioId as number),
        enabled: enabled && lensId != null && scenarioId != null,
        staleTime: LENS_SCENARIO_CONFIG_STALE_TIME_MS,
    });
}

export default useFetchLensScenarioConfig;
